import React from "react";
import { motion } from "framer-motion";
import { HiOutlineArrowUpRight } from "react-icons/hi2";
import img1 from "../../Assets/Imagre1.png";
import img2 from "../../Assets/Image2.png";
import img3 from "../../Assets/Image3.png";

const ImageContainer = () => {
  // Shared variants for image cards
  const cardVariants = {
    hidden: { opacity: 0, y: 60, scale: 0.94 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.9, ease: "easeOut" },
    },
  };

  const imageVariants = {
    rest: { scale: 1 },
    hover: { scale: 1.08, transition: { duration: 0.6, ease: "easeOut" } },
  };

  const overlayVariants = {
    rest: { opacity: 0, y: 20 },
    hover: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
  };

  return (
    <section className="w-full bg-white px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 py-4 sm:py-6 md:py-8 lg:py-10 xl:py-12">
      <div className="max-w-screen-2xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-10 h-auto md:h-[450px] lg:h-[550px]">
        {/* Left Image */}
        <motion.div
          className="overflow-hidden rounded-xl h-[300px] md:h-full"
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          whileHover="hover"
        >
          <motion.img
            src={img1}
            alt="Port Logistics"
            className="w-full h-full object-cover"
            variants={imageVariants}
            initial="rest"
            whileHover="hover"
          />
        </motion.div>

        {/* Middle Image with Overlay */}
        <motion.div
          className="relative overflow-hidden rounded-xl group h-[300px] md:h-full"
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          whileHover="hover"
        >
          <motion.img
            src={img2}
            alt="Robotic Warehouse"
            className="w-full h-full object-cover"
            variants={imageVariants}
            initial="rest"
            whileHover="hover"
          />

          {/* Overlay Text – animates on hover */}
          <motion.div
            className="absolute bottom-8 left-8 text-white z-10 pointer-events-none"
            variants={overlayVariants}
            initial="rest"
            whileHover="hover"
          >
            <p className="text-sm font-bold tracking-wider mb-1">Lorem</p>
            <div className="flex items-center gap-2">
              <h3 className="text-2xl font-bold">Lorem Ipsum</h3>
              <motion.div
                animate={{ rotate: 0 }}
                whileHover={{ rotate: 45, scale: 1.2 }}
                transition={{ duration: 0.4 }}
              >
                <HiOutlineArrowUpRight className="text-brandOrange text-3xl mt-1" />
              </motion.div>
            </div>
          </motion.div>

          {/* Subtle gradient – optional fade-in */}
          <motion.div
            className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/60 to-transparent pointer-events-none"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, delay: 0.4 }}
          />
        </motion.div>

        {/* Right Image */}
        <motion.div
          className="overflow-hidden rounded-xl h-[300px] md:h-full"
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          whileHover="hover"
        >
          <motion.img
            src={img3}
            alt="Modern Warehouse"
            className="w-full h-full object-cover"
            variants={imageVariants}
            initial="rest"
            whileHover="hover"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default ImageContainer;
